import React, { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { showAlertAction, hideAlertAction } from "../../actions/alertActions"
import { requestLoadConceptFromAPI, setUnsaveFlag } from "../../actions/buildconceptActions"
import { setCurrentSearchAction } from "../../actions/currentSearchActions"
import { clearTimelineRequest, getGraphDataRequestClear } from "../../actions/createTimelineActions"
// eslint-disable-next-line
import ModalAnzyz from "../ModalAnzyz"
// eslint-disable-next-line
import SimplePopover from "../build/btnInfo"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { makeStyles } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import InfoDialog from "../common/InfoDialog"
import uuid from "react-uuid"
import { setSearchLoad, deleteSearchLoad, saveNewSearch } from "../../actions/savedSearchActions"
import SavedSearches from "../common/SavedSearches"
import SaveNewSearch from "../common/SaveNewSearch"
import { setSelectedSearch } from "../../actions/searchActions"
import { setAIBase } from "../../actions/multiAiBase"
import { PAYLOAD_DATE_FORMAT, getQueryParams, parsePayload } from "../../utils"
import moment from "moment"

const SearchTimeline = ({
	createSearch,
	setInfoPage,
	border,
	setBorder,
	setUpdateFiletypes,
	setFilterList,
	filterList,
	setFileTypesRefresh,
	docCount,
	toRetainFilters = true,
	searchText = "",
	categories = [],
	setRecordsPerPage,
	setTimelineSearchCall,
	handleReset,
	setSelectedGraphDateRange,
	initilaselectedDateRange,
	clearAll,
	setClearAll,
	setIsClearClick,
	reviewSelectedCallback = () => {},
	filters,
	mapFiltersToState,
}) => {
	/* ******************* REDUX STORE ******************* */
	// Get inputs results
	const dispatch = useDispatch()
	const savedConceptList = useSelector((state) => state.buildconcept.user_saved_build_concepts)
	const loadedAPIData = useSelector((state) => state.buildconcept.loadedAPIData)
	const isUnsavedDate = useSelector((state) => state.buildconcept.unsaved_data)
	const lastestSearch = useSelector((state) => state.currentSearchs.timeline)
	const lastSearch = useSelector((state) => state.savedSearch.savedSearchs)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	const selectedSearch = useSelector((state) => state.savedSearch?.selectedSearch)
	const selectedBase = useSelector((state) => state.multiBase.selectedBase)
	const selectedReviewIds = useSelector((state) => state.review?.restrictIds)
	const prevSelectedId = selectedBase.prev
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// Component states
	const [inputSearch, updateInputSearch] = useState(lastestSearch.text)
	const [inputSaveConcept, updateInputSaveConcept] = useState("")
	const [inputLoadSearch, updateInputLoadSearch] = useState("")
	// eslint-disable-next-line
	const [modalUnsavedChanges, setModalUnsavedChanges] = useState(false)

	//Autocomplete state
	const [valueAutocomplete, setValueAutocomplete] = useState(lastestSearch.concepts)
	// eslint-disable-next-line
	const [inputValueAutocomplete, setInputValueAutocomplete] = useState("")
	// Clear Search State
	const [clearSearch, setClearSearch] = useState(false)
	// Refresh Autocomplet Element for deleting tags
	const [autoCompleteRefresh, setAutoCompleteRefresh] = useState(0)

	/* SAVE SEARCHS */

	const [showSavedList, setShowSavedList] = useState(false)
	//Show or hide Save Button
	//Show saved query input
	const [showToSaveForm, setShowToSaveForm] = useState(false)
	//Show saved query detail
	const [showSaveQueryDetail, setShowSaveQueryDetail] = useState("")
	//Data for saved query
	const [saveQueryData, setSaveQueryData] = useState({ name: "", share: 0, id: "" })

	// eslint-disable-next-line
	const [showSaveButton, setShowSaveButton] = useState(false)
	// Pagination
	const [currentpageSavedConcepts, setCurrentPageSavedConcepts] = useState(1)
	// eslint-disable-next-line
	const [totalpagesSavedConcepts, setTotalPagesSavedConcepts] = useState(1)
	const [currentpageSharedConcepts, setCurrentPageSharedConcepts] = useState(1)
	// eslint-disable-next-line
	const [totalpagesSharedConcepts, setTotalPagesSharedConcepts] = useState(1)
	// Refresh Share checkbox Element for deleting tags
	const [shareRefresh, setShareRefresh] = useState(0)

	const useOutsideAlerter = (ref) => {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setShowSavedList(false)
				}
			}

			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside)
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside)
			}
		}, [ref])
	}
	const useOutsideAlerterSave = (ref) => {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setShowToSaveForm(false)
				}
			}

			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside)
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside)
			}
		}, [ref])
	}
	const wrapperRef = useRef(null)
	const wrapperRefSave = useRef(null)
	useOutsideAlerter(wrapperRef)
	useOutsideAlerterSave(wrapperRefSave)
	const loadSearchFromStorage = (item, e) => {
		updateInputSearch(item.inputSearch)
		setValueAutocomplete(item.valueAutocomplete)
		setAutoCompleteRefresh(Math.floor(Math.random() * 10000))
		// submitSearchForm(e);
		setTimeout(function () {
			var searchButton = document.getElementById("searchButton")
			searchButton.click()
		}, 500)
		setSaveQueryData({ name: item.name, share: item.share, id: item.id })
		setShareRefresh(Math.random())
		let element = document.getElementById("clearButton")
		element.classList.remove("disabled")
		element.classList.add("showClearButton")
	}

	useEffect(() => {
		setAutoCompleteRefresh(Math.random())
	}, [lastestSearch.concepts])
	/* END SAVE SEARCHS */
	/* ******************* END REACT STATES ******************* */

	/* ******************* USE-EFFECTS ******************* */
	useEffect(() => {
		return () => {
			dispatch(setSelectedSearch(undefined)) //on unmount Selected Search set to undefined
		}
	}, [])

	useEffect(() => {
		if (border === true) {
			let element = document.getElementById("inputSearch")
			element.classList.add("inputBorder")
			element.focus()
		} else {
			let element = document.getElementById("inputSearch")
			element.classList.remove("inputBorder")
		}
	}, [border])

	useEffect(() => {
		//Refrech the save field with the current concept name
		if (loadedAPIData.description) {
			updateInputSaveConcept(loadedAPIData.description)
		}
		return
	}, [loadedAPIData.description])

	// Reset lastestSearch.text to empty
	useEffect(() => {
		dispatch(setCurrentSearchAction(inputSearch, valueAutocomplete, "timeline"))
	}, [clearSearch])

	useEffect(() => {
		let element = document.getElementById("clearButton")
		if (valueAutocomplete.length > 0 || !!inputSearch) {
			element.classList.remove("disabled")
			element.classList.add("showClearButton")
		} else {
			element.classList.remove("showClearButton")
			element.classList.add("disabled")
		}
	}, [valueAutocomplete])

	useEffect(() => {
		setAutoCompleteRefresh(Math.random())
	}, [lastestSearch.concepts])

	useEffect(() => {
		if (selectedBaseId !== prevSelectedId) {
			updateClearSearch(false)
			dispatch(setAIBase({ ...selectedBase, prev: selectedBaseId }))
		}
	}, [selectedBaseId])
	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	// Clear function
	const updateClearSearch = (shouldStoreUpdate) => {
		updateInputSearch("")
		setValueAutocomplete([])
		setInfoPage(true)
		setTimelineSearchCall(false)
		handleReset()
		setClearSearch(true)
		setSaveQueryData({ name: "", share: 0, id: "" })
		dispatch(setSelectedSearch(undefined))
		reviewSelectedCallback(true)
		dispatch(setCurrentSearchAction("", [], "timeline"))
		setShareRefresh(Math.random())
		setShowToSaveForm(false)
		let element = document.getElementById("clearButton")
		element.classList.remove("showClearButton")
		element.classList.add("disabled")
		if (shouldStoreUpdate) dispatch(clearTimelineRequest())
		setAutoCompleteRefresh(Math.floor(Math.random() * 10000))
		if (shouldStoreUpdate) dispatch(getGraphDataRequestClear())
		setSelectedGraphDateRange(initilaselectedDateRange)
		//if timeline is in review context then load the review data
		//if (selectedReviewIds?.length > 0) createSearch("", [])
	}

	useEffect(() => {
		if (!toRetainFilters) {
			if (searchText) updateSearch({ target: { value: searchText } })
			if (categories?.length > 0) setValueAutocomplete((prevData) => categories)
		}
	}, [toRetainFilters, searchText])

	useEffect(() => {
		if (clearAll) {
			updateClearSearch(true)
			dispatch(setCurrentSearchAction("", [], "timeline"))
			setClearAll(false)
		}
	}, [clearAll])

	// Input function
	const updateSearch = (e) => {
		updateInputSearch(e.target.value)
		let element = document.getElementById("clearButton")
		if (e.target.value !== "") {
			element.classList.remove("disabled")
			element.classList.add("showClearButton")
		} else {
			element.classList.remove("showClearButton")
			element.classList.add("disabled")
		}
	}
	// eslint-disable-next-line
	const updateSaveConcept = (e) => {
		updateInputSaveConcept(e.target.value)
	}
	// eslint-disable-next-line
	const updateLoadSearch = (e) => {
		updateInputLoadSearch(e.target.value)
	}

	// eslint-disable-next-line
	let continueAfterModal = () => {
		dispatch(setUnsaveFlag(false))
		forceSearch()
	}
	// Form submitted
	const submitSearchForm = (e) => {
		e.preventDefault()
		//handleReset()
		setInfoPage(false)

		// Form validation or other function.
		if (inputSearch.trim() === "" && valueAutocomplete.length === 0) {
			//Error, there is nothing type to search
			const alert1 = {
				msg: "Please type some text or select one or more concepts to start exploring",
				class: "alert alert-danger",
			}
			dispatch(showAlertAction(alert1))
			return
		}

		//Check if unsaved data
		if (isUnsavedDate) {
			setModalUnsavedChanges(true)
			continueAfterModal = () => {
				dispatch(setUnsaveFlag(false))
				forceSearch()
			}
			return
		}
		forceSearch()
		setSelectedGraphDateRange(initilaselectedDateRange)
	}

	const forceSearch = () => {
		setRecordsPerPage(10)
		setModalUnsavedChanges(false)
		// Create Filter
		dispatch(hideAlertAction())
		dispatch(setCurrentSearchAction(inputSearch, valueAutocomplete, "timeline"))
		createSearch(inputSearch || "", valueAutocomplete || [], 10, 0, {}, parsePayload(filters))
		updateInputSaveConcept("")
		if (showSaveButton == false) {
			setShowSaveButton(!showSaveButton)
		}
		let element = document.getElementById("clearButton")
		element.classList.remove("disabled")
		element.classList.add("showClearButton")
	}

	// eslint-disable-next-line
	const loadSavedContent = (ext_id) => {
		//Check if unsaved data
		if (isUnsavedDate) {
			setModalUnsavedChanges(true)
			continueAfterModal = () => {
				dispatch(setUnsaveFlag(false))
				loadSavedContent(ext_id)
			}
			return
		}
		dispatch(requestLoadConceptFromAPI(ext_id))
	}

	// Autocomplete - Search in Concept
	const useStyles = makeStyles((theme) => ({
		root: {
			width: 600,
			"& > * + *": {
				marginTop: theme.spacing(2),
			},
		},
	}))

	// Save new Search
	const saveSearch = () => {
		let continueSaving = true
		Array.isArray(lastSearch) &&
			lastSearch?.forEach((element) => {
				if (element?.search_name === saveQueryData?.name) {
					if (saveQueryData?.share != element?.params?.published) {
						setSearchDelete(element?.search_id)
					} else {
						alert("The name entered to save the search is currently in use. Please, choose another name to continue")
						continueSaving = false
					}
				}
			})

		if (continueSaving === true) {
			let searchUUID
			if (saveQueryData?.id === "") {
				searchUUID = uuid()
				setSaveQueryData({ ...saveQueryData, id: searchUUID })
			} else {
				searchUUID = saveQueryData?.id
			}
			const selectedConceptsIdList = valueAutocomplete.map((conceptObj) => conceptObj?.id)

			const queryParam = getQueryParams()
			let appliedFilters = parsePayload(filters)

			if (queryParam?.tagged_date?.data?.length) {
				appliedFilters = {
					...appliedFilters,
					tagged_date: {
						...filters.tagged_date,
						data: [
							moment(queryParam?.tagged_date?.data[0]).format(PAYLOAD_DATE_FORMAT),
							moment(queryParam?.tagged_date?.data[1]).format(PAYLOAD_DATE_FORMAT),
						],
					},
				}
			}

			let newSearch = {
				name: saveQueryData?.name,
				id: selectedSearch?.id,
				docs_count: docCount,
				shared: saveQueryData?.share,
				params: {
					text: inputSearch,
					categories: selectedConceptsIdList,
					source: filterList,
					return_count: 10,
					skip_count: 0,
					dynamic_search: 0,
					published: saveQueryData?.share,
					suppress_content: false,
					mark_dates: 0,
					mark_emails: 0,
					filters: appliedFilters,
					//creation_time: new Date()
				},
			}
			dispatch(saveNewSearch(newSearch))
		}
	}

	// Delete search
	const setSearchDelete = (idSearch) => {
		dispatch(deleteSearchLoad(idSearch))
		if (selectedSearch?.id === idSearch) {
			//if selectedSearch and idSearch is same then clear the current view
			updateClearSearch(true)
		}
	}

	// Save search
	// const setSearchReducer = () =>{
	//   dispatch(setSearchLoad({
	//     id: (saveQueryData.id===""? uuid():saveQueryData.id),
	//     inputSearch: inputSearch,
	//     valueAutocomplete: valueAutocomplete,
	//     date: Date.now(),
	//     name: saveQueryData.name,
	//     share: saveQueryData.share
	//   }));
	// }

	const loadSearchFromReducer = (item, e) => {
		let name = ""
		if (item.hasOwnProperty(item.search_name)) {
			name = item.search_name
		} else {
			name = item.name
		}
		updateInputSearch(item.params.text)
		setValueAutocomplete(item.params.categories)
		setAutoCompleteRefresh(Math.floor(Math.random() * 10000))
		//todo: we have to remove this code
		// setTimeout(function () {
		// 	var searchButton = document.getElementById("searchButton")
		// 	searchButton.click()
		// }, 500)
		setSaveQueryData({ name: name, share: item.params.published, id: item.search_id })
		dispatch(setSelectedSearch(item))
		setShareRefresh(Math.random())
		let element = document.getElementById("clearButton")
		element.classList.remove("disabled")
		element.classList.add("showClearButton")
		setSelectedGraphDateRange(initilaselectedDateRange)
		mapFiltersToState(item?.params?.filters)

		//trigger the search
		createSearch(item.params?.text || "", item.params?.categories || [], 10, 0, {}, item?.params?.filters)
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES ******************* */
	const classes = useStyles()

	let elementsPerPageSavedConcepts = 10
	// eslint-disable-next-line
	let calcTotalPagesSavedConcepts = Math.ceil(savedConceptList.length / elementsPerPageSavedConcepts)

	let elementsPerPageSharedConcepts = 10
	// eslint-disable-next-line
	let calcTotalPagesSharedConcepts = Math.ceil(savedConceptList.length / elementsPerPageSharedConcepts)

	if (inputLoadSearch) {
		elementsPerPageSavedConcepts = 1000
		// eslint-disable-next-line
		calcTotalPagesSavedConcepts = Math.ceil(savedConceptList.length / elementsPerPageSavedConcepts)

		elementsPerPageSharedConcepts = 1000
		// eslint-disable-next-line
		calcTotalPagesSharedConcepts = Math.ceil(savedConceptList.length / elementsPerPageSharedConcepts)
	}
	/* ******************* END VARIABLES ******************* */

	return (
		<div className="container-fluid my-3 p-2 pb-4 border-bottom">
			<form onSubmit={submitSearchForm}>
				<div className="d-flex justify-content-between">
					<input
						id="inputSearch"
						type="text"
						name="search"
						value={inputSearch}
						onChange={updateSearch}
						className=" mb-0 col-10 px-3 searchBar"
						placeholder="Search either by free text or add a concept from below"
						data-cy="create_timeline__search_input"
						style={{ flex: 1 }}
					/>

					<div className="d-flex justify-content-between">
						<button
							type="submit"
							className="btn btn-primary btnInputConcept"
							data-cy="create_timeline_search_button"
							id="searchButton"
						>
							Search
						</button>

						<button
							id="clearButton"
							type="button"
							className="btn btn-primary btnInputConcept"
							onClick={() => {
								updateClearSearch(true)
								setIsClearClick((prev) => true)
							}}
						>
							Clear all
						</button>
					</div>
				</div>

				<div className="mt-3 d-flex justify-content-between align-items-center">
					<div>
						<div className={`${classes.root} autoComplete float-start`}>
							<Autocomplete
								key={autoCompleteRefresh}
								multiple
								id="size-small-standard-multi"
								size="small"
								options={savedConceptList}
								//defaultValue={valueAutocomplete}
								value={valueAutocomplete}
								getOptionLabel={(option) => option.description}
								renderInput={(params) => (
									<TextField {...params} variant="standard" label="Search in concept" placeholder="concepts" />
								)}
								//value={valueAutocomplete}
								onChange={(event, newValue) => {
									setValueAutocomplete(newValue)
								}}
								//inputValue={inputValueAutocomplete}
								data-cy="choose_concepts"
							/>
						</div>
						<div className="inline-block" style={{ paddingTop: "10px" }}>
							<InfoDialog btninfo="searchContextTimeline" />
						</div>
					</div>

					{/* SAVE SEACH */}
					<div className="inline-block pr-0 v-top" ref={wrapperRef} id="load_concept">
						<button
							style={{ display: lastSearch.length > 0 ? "block" : "none" }}
							data-cy="load_button"
							className="btn btn-outline-primary btn-sm height-35 w100 min100"
							onClick={(e) => {
								e.preventDefault()
								setShowSavedList(!showSavedList)
							}}
						>
							Load a saved search
						</button>
						<SavedSearches
							showSavedList={showSavedList}
							lastSearch={lastSearch}
							showSaveQueryDetail={showSaveQueryDetail}
							loadSearchFromStorage={loadSearchFromStorage}
							setShowSavedList={setShowSavedList}
							setShowSaveQueryDetail={setShowSaveQueryDetail}
							setSearchDelete={setSearchDelete}
							loadSearchFromReducer={loadSearchFromReducer}
							setUpdateFiletypes={setUpdateFiletypes}
							setFilterList={setFilterList}
							filterList={filterList}
							setFileTypesRefresh={setFileTypesRefresh}
							setSaveQueryData={setSaveQueryData}
							saveQueryData={saveQueryData}
						/>
					</div>
					{/* END SAVE SEARCH */}
				</div>
				{docCount !== 0 && (
					<SaveNewSearch
						saveQueryData={saveQueryData}
						setSaveQueryData={setSaveQueryData}
						shareRefresh={shareRefresh}
						setTotalPagesSavedConcepts={setTotalPagesSavedConcepts}
						calcTotalPagesSavedConcepts={calcTotalPagesSavedConcepts}
						setTotalPagesSharedConcepts={setTotalPagesSharedConcepts}
						calcTotalPagesSharedConcepts={calcTotalPagesSharedConcepts}
						// setSearchReducer={setSearchReducer}
						setShowToSaveForm={setShowToSaveForm}
						saveSearch={saveSearch}
						setShareRefresh={setShareRefresh}
						isAnyDataLoaded={inputSearch?.trim("")?.length > 0 || valueAutocomplete?.length > 0}
						isTimeline={true}
					/>
				)}
			</form>
		</div>
	)
}

export default SearchTimeline
